import SecurityAddressOrPostcode from './SecurityAddressOrPostcode';

export default SecurityAddressOrPostcode;
